export const CREATE_EXPERIENCE = "CREATE_EXPERIENCE";
export const FETCH_EXPERIENCES = "FETCH_EXPERIENCES";
export const FETCH_EXPERIENCE = "FETCH_EXPERIENCE";
export const EDIT_EXPERIENCE = "EDIT_EXPERIENCE";
export const DELETE_EXPERIENCE = "DELETE_EXPERIENCE";
